import { waitForMessage } from '../factories/waitForMessage';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { inspectionContract } from 'shared/domain/inspection/inspectionContract';

export const waitForInspections = waitForMessage(
  inspectionContract,
  DomainMessagesTypes.allInspections
);
